import { add, listen, qs, qsa, remove, toggle } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';

const selectors = {
  collection: '[data-collection]',
  image: '[data-image]',
  overlay: '[data-overlay]',
  trigger: '[data-trigger]',
  submenu: '[data-submenu]',
};

export default function MegaNav(node) { 
  const focusTrap = createFocusTrap(node);

  const events = [
    // Click on the overlay and close mega nav
    listen(qs(selectors.overlay, node), 'click', close),

    // Close on escape
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ].filter(Boolean);

  function open(options = {}) {
    add(node, 'active');
    setTimeout(() => {
      focusTrap.activate();
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, 'visible');
      node.removeAttribute("hidden");
    }, 50);
  }

  function close() {
    remove(node, 'visible');
    node.setAttribute("hidden", "");
    setTimeout(() => {
      remove(node, 'active');
      enableBodyScroll(node);
      focusTrap.deactivate();

      events.forEach(evt => evt());
    }, 350);
  }

  return { open, close };
}
